import React, { useState, useEffect, useMemo } from "react";
import Header from "../../layout/Header";
import { Tabs, Tab, Modal } from "react-bootstrap";
import { backIcon2, profileImage, transaction } from "../../../Image/Index";
import {
  getDate,
  getDisplayDate,
  getRouteFromSource,
} from "../../../utils/helper";
import {
  transactionRedeem,
  customerView,
  RedeemVoucher,
  getVoucherTemplateStatusByCode,
  getVoucherTemplateByMerchantCode,
} from "../campaigns/services";
import TransactionViewModal from "../transactionsList/TransactionViewModal";
import Page from "../Pagination";
import RedeemRewardsModal from "./RedeemRewardsModal";
import swal from "sweetalert";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import RedeemableModal from "./RedeemableModal";
import { decrypt } from "../../../utils/encodingdecoding";
import CardUpdateModal from "./CardUpdateModal";
import { clearCustomer, getCustomer } from "../../../actions/customer";
import { connect } from "react-redux";
import {
  getSchemaList,
  transactionRefund,
  voucherPurchase,
} from "../../../actions/auth";
import CustomerAddEditModal from "./CustomerAddEditModal";
import RemarkModal from "../../voucher/RemarkModal";
import {
  edsringMerchantId,
  starHealthMerchantId,
  starblazeMerchantId,
} from "../../../utils";

const CustomerView = ({ Customer, getCustomer, clearCustomer }) => {
  let navigate = useNavigate();
  const [totalInvest, setTotalInvest] = useState();
  const [remarksModal, setRemarksModal] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState({});
  const [remarks, setRemarks] = useState("");
  const [showImageZoom, setShowImageZoom] = useState(false);

  const location = useLocation();
  const { id } = useParams();
  const TransactionType = {
    ADD_FUND: "ADD_FUND",
    INVESTMENT: "INVESTMENT",
  };
  let Id = decrypt(localStorage.getItem("Id"));
  const [response, setResponse] = useState({});
  const [loader, setLoader] = useState(true);
  const [state, setState] = useState({
    name: "",
    mobile: "",
    referralcode: "",
    referredby: "",
    tier: "",
    customerid: "",
    membershipType: "",
    email: "",
    customer_Code: "",
    profileImageUrl: "",
    merchant_Id: "",
    availableValue: "",
    totalAvailableValue: 0,
    totalEarnPoints: "0",
    totalExpiredPoints: "0",
    totalRedeemPoints: "0",
    totalLockValue: "0",
    transferValue: "0",
    redeemablePoint: 0,
    walletSummary: [],
    transaction_s: [],
    vouchersList: [],
    inputRedeemPoints: "",
    error: "",
    successMsg: "",
    close: false,
    activityLogs: [],
    limit: 5,
    total: 0,
    disable: true,
    memberCardNumber: "",
    customerData: "",
  });
  const [showLogin, setShowLogin] = useState(false);
  const [redeemModalShow, setRedeemModalShow] = useState(false);
  const [redeemableModalShow, setRedeemableModalShow] = useState(false);
  const [membershipCard, setMembershipCard] = useState({
    cardUpdateModalShow: false,
    cardNumber: "",
  });
  const [transactionId, setTransactionId] = useState("");
  const [schemaData, setSchemaData] = useState();
  const [redeem, setRedeem] = useState({
    customer: {
      customercode: "",
    },
    redeemDetail: {
      walletType: "point",
      values: "",
      transactionType: "redeem",
      transactionDate: "",
      ...(decrypt(localStorage.getItem("Id")) === edsringMerchantId && {
        remarks,
      }),
    },
  });
  const [voucher, setVoucher] = useState({
    qualifiedVoucherList: [],
    flag: true,
    voucherTemplate: [],
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPagev, setCurrentPagev] = useState(0);

  const {
    name,
    mobile,
    referralcode,
    referredby,
    customerid,
    membershipType,
    tier,
    email,
    customer_Code,
    profileImageUrl,
    availableValue,
    totalAvailableValue,
    totalEarnPoints,
    totalExpiredPoints,
    totalRedeemPoints,
    totalLockValue,
    transferValue,
    transaction_s,
    error,
    inputRedeemPoints,
    successMsg,
    activityLogs,
    limit,
    total,
    disable,
    redeemablePoint,
    walletSummary,
    memberCardNumber,
    customerData,
  } = state;
  const { customer, redeemDetail } = redeem;
  const { qualifiedVoucherList, flag, voucherTemplate } = voucher;
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source");

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([fetch(), getCustomerSchema()]);
      } catch (error) {
        setLoader(false);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    if (flag) {
      fetchVoucher(); // eslint-disable-next-line
    }
  }, [flag]);

  useEffect(() => {
    if (!Customer?.data?.data?.data?.length) {
      fetchCustomerList();
    }
    // eslint-disable-next-line
  }, []);

  const fetchCustomerList = async () => {
    await clearCustomer();
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let id = localStorage.getItem("Id");
    await getCustomer(token?.access_token, id, 0, 50, " ");
  };

  useEffect(() => {
    const voucherType = [];
    response?.transactions?.length &&
      response?.transactions?.map(
        (value) =>
          value?.qualifiedCampaign?.length > 0 &&
          value?.qualifiedCampaign[0]?.type === "voucher" &&
          voucherType.push(value),
      );
    setState({
      ...state,
      customerData: response?.customer,
      name: response?.customer?.name ? response?.customer?.name : "",
      mobile: response?.customer?.mobile ? response.customer.mobile : "",
      referralcode: response?.customer?.referralcode
        ? response.customer.referralcode
        : "",
      referredby: response?.customer?.referredby
        ? response.customer.referredby
        : "N/A",
      tier: response?.customer?.tier?.name
        ? response.customer.tier?.name
        : "N/A",
      customerid: response?.customer?.customerid
        ? response.customer.customerid
        : "",
      membershipType: response?.customer?.membership?.membershipType
        ? response?.customer?.membership?.membershipType
        : "",
      email: response?.customer?.email ? response.customer.email : "",
      customer_Code: response?.customer?.customercode,
      profileImageUrl: response?.customer?.profileimageurl,
      memberCardNumber: response?.customer?.memberCardNumber
        ? response?.customer?.memberCardNumber
        : "",
      availableValue:
        response?.walletsDetail?.availableValue != null
          ? response?.walletsDetail?.availableValue
          : 0,
      totalEarnPoints:
        response?.walletsDetail?.earnedValue != null
          ? response?.walletsDetail?.earnedValue
          : 0,
      totalRedeemPoints:
        response?.walletsDetail?.redeemValue != null
          ? response?.walletsDetail?.redeemValue
          : 0,
      totalLockValue:
        response?.walletsDetail?.totalLockValue != null
          ? response?.walletsDetail?.totalLockValue
          : 0,
      transferValue:
        response?.walletsDetail?.transferValue != null
          ? response?.walletsDetail?.transferValue
          : 0,
      totalExpiredPoints:
        response?.walletsDetail?.expiredValue != null
          ? response?.walletsDetail?.expiredValue
          : 0,
      totalAvailableValue:
        response?.walletsDetail?.TotalavailableValue != null
          ? response?.walletsDetail?.TotalavailableValue
          : 0,
      redeemablePoint:
        response?.walletsDetail?.earnedValueRedemptionAfterDate != null
          ? response?.walletsDetail?.earnedValueRedemptionAfterDate
          : 0,
      walletSummary: response?.WalletSummary?.filter(
        (wallet) =>
          getDate(wallet?.redeemableAfterDate, "YYYY-MM-DD") >
            getDate(new Date(), "YYYY-MM-DD") && wallet,
      ),
      transaction_s: response?.transactions ? response?.transactions : [],
      inputRedeemPoints:
        response?.walletsDetail?.TotalavailableValue != null
          ? response?.walletsDetail?.TotalavailableValue
          : 0,
      activityLogs: response?.activityLogs ? response?.activityLogs : [],
      total: response?.transactions ? response?.transactions.length : 0,
    });
    if (response && Object.keys(response).length) {
      setLoader(false);
    }
    // eslint-disable-next-line
  }, [response]);
  useEffect(() => {
    const totalInvestment = transaction_s
      .filter(
        (transaction) =>
          transaction?.transactionDetail?.bitType === "INVESTMENT",
      )
      .reduce(
        (sum, transaction) =>
          sum + (transaction?.transactionDetail?.totalAmount || 0),
        0,
      );
    setTotalInvest(totalInvestment);
  }, [transaction_s]);

  const [matchedVoucherStatus, setMatchedVoucherStatus] = useState([]);
  useEffect(() => {
    let temp = [];
    // response?.transactions?.length &&
    //   response?.transactions?.map((e) => {
    //     if (e.qualifiedCampaign && e.qualifiedCampaign.length) {
    //       e.qualifiedCampaign.filter((item) => {
    //         if (item.type === "voucher") {
    //           return temp.push({
    //             voucherCode: item.voucherCode,
    //             value: item.value,
    //             templateCode: item.voucherTemplateCode,
    //             transactionType: e.transactionDetail.transactionType,
    //             customerCode: e.customer[0]?.customercode,
    //             transactionDate: new Date().toISOString(),
    //           });
    //         }
    //         return null;
    //       });
    //     }
    //     return null;
    //   });

    temp = response?.WalletSummary?.length
      ? response?.WalletSummary?.filter(
          (e) => "walletType" in e && e.walletType === "Voucher",
        )
      : [];
    if (temp.length) {
      temp = temp.map((_item) => ({
        voucherCode: _item?.voucherCode,
        value: _item?.voucherValue,
        templateCode: _item?.voucherTemplateCode,
        earnedValue: _item?.earnedValue,
        transactionType: _item?.transactionType,
        customerCode: _item?.customercode,
        transactionDate: _item?.earnedDate,
        ...(decrypt(localStorage.getItem("Id")) === edsringMerchantId && {
          remarks: _item?.remarks,
        }),
      }));
    }

    setVoucher({ ...voucher, qualifiedVoucherList: temp?.reverse() });
    // eslint-disable-next-line
  }, [response, voucherTemplate]);
  const handleVoucher = async () => {
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const body = {
      customercode: customer_Code,
    };
    let voucherStatusResponse = await getVoucherTemplateStatusByCode(
      token?.access_token,
      body,
    );

    matchVoucherCodes(voucherStatusResponse);
  };

  useEffect(() => {
    customer_Code && handleVoucher();
  }, [customer_Code]);

  const matchVoucherCodes = (voucherStatusResponse) => {
    const matchedVouchers = [];
    if (Array.isArray(voucherStatusResponse) && voucherStatusResponse?.length) {
      voucherStatusResponse?.forEach((voucherStatus) => {
        voucher?.qualifiedVoucherList?.forEach((voucher) => {
          if (voucherStatus?.voucherCode === voucher?.voucherCode) {
            matchedVouchers.push({
              voucherTemplateCode: voucherStatus?.voucherTemplateCode,
              voucherCode: voucherStatus?.voucherCode,
              status: voucherStatus?.voucherUsed,
            });
          }
        });
      });
    }
    storeVoucherStatus(matchedVouchers);
  };
  const storeVoucherStatus = (matchedVouchers) => {
    setMatchedVoucherStatus(matchedVouchers);
  };

  useEffect(() => {
    let tempCustomer_code = customer_Code;
    let tempInputRedeemPoints = parseInt(inputRedeemPoints);
    setRedeem({
      ...redeem,
      customer: { ...customer, customercode: tempCustomer_code },
      redeemDetail: {
        ...redeemDetail,
        values: tempInputRedeemPoints,
        transactionDate: getDate(new Date(), "YYYY-MM-DD"),
        ...(decrypt(localStorage.getItem("Id")) === edsringMerchantId && {
          remarks,
        }),
      },
    });
  }, [customer_Code, inputRedeemPoints, totalAvailableValue]);

  useEffect(() => {
    if (totalAvailableValue > 0) {
      setState({ ...state, disable: false });
    }
  }, [totalAvailableValue]);
  const path = window.location.pathname;
  const customerPath = path.split("/")[2];

  const fetch = async () => {
    let tempToken = JSON.parse(localStorage.getItem("token_gen"));
    tempToken = tempToken?.access_token;
    const res = await customerView(tempToken, customerPath);
    setResponse(res);
  };

  const getCustomerSchema = async () => {
    const token = JSON.parse(localStorage.getItem("token_gen"));

    const res = await getSchemaList(token?.access_token);

    if (res?.schema?.properties) {
      const result = Object.keys(res?.schema?.properties)

        .filter((key) => key !== "profileimageurl")

        .filter((key) => res?.schema?.properties[key]?.isFormView)
        .map((key) => ({
          ...res?.schema?.properties[key],
          fielddisplayname:
            res?.schema?.properties[key]?.fielddisplayname ||
            key.charAt(0).toUpperCase() + key.slice(1),
          fieldname: key,
        }));

      setSchemaData(result);
    }
  };

  const fetchVoucher = async () => {
    let tempToken = JSON.parse(localStorage.getItem("token_gen"));
    tempToken = tempToken?.access_token;
    setLoader(true);
    await getVoucherTemplateByMerchantCode(tempToken)
      .then((res) => {
        setVoucher({ ...voucher, voucherTemplate: res.data });
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const handleDownloadProfileImage = async () => {
    const imageUrl = profileImageUrl || profileImage;
    try {
      const res = await window.fetch(imageUrl);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${customer_Code || "profile"}-image.jpg`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(imageUrl, "_blank");
    }
  };

  const getVoucherDate = (value) => {
    var expdate = "";
    voucherTemplate?.length &&
      voucherTemplate?.map((val) => {
        if (val.code === value) expdate = val?.voucherValidityDate?.endDate;
      });
    return expdate;
  };
  const getValue = (value) => {
    var earningValue = "";
    voucherTemplate?.length &&
      voucherTemplate?.map((val) => {
        if (val.code === value) earningValue = val.voucherValue;
      });
    return earningValue;
  };
  const handleRedeemtion = async (value, camp) => {
    setLoader(true);
    let tempToken = JSON.parse(localStorage.getItem("token_gen"));
    tempToken = tempToken?.access_token;
    let body = {};
    body.customer = {
      customercode: value.customerCode,
    };

    body.redeemDetail = {
      walletType: "Voucher",
      voucherCode: value.voucherCode,
      voucherTemplateCode: value.templateCode,
      transactionType: "redeem",
      transactionDate: value.transactionDate,
      ...(decrypt(localStorage.getItem("Id")) === edsringMerchantId && {
        remarks,
      }),
    };
    await RedeemVoucher(tempToken, body).then((res) => {
      if (res?.status === 400) {
        swal({
          position: "center",
          icon: "error",
          title: res.message,
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        swal({
          position: "center",
          icon: "success",
          title: "Voucher Redeemed Successfully",
          showConfirmButton: false,
          timer: 5000,
        });
      }
      setLoader(false);
      handleVoucher();
      setVoucher((prev) => ({
        ...prev,
        qualifiedVoucherList: prev.qualifiedVoucherList.map((item) =>
          item.voucherCode === value.voucherCode ? { ...item, remarks } : item,
        ),
      }));
    });
    // await fetch();
    if (decrypt(localStorage.getItem("merchantcode")) === edsringMerchantId) {
      setRemarks("");
      setSelectedVoucher({});
      setRemarksModal(false);
    }
  };
  const handleChange = (e, minimumValue) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
    if (e.target.value < minimumValue || totalAvailableValue < e.target.value) {
      if (!e.target.value || e.target.value <= 0) {
        setState({ ...state, error: null, disable: true });
      }
      if (
        (e.target.value || e.target.value > 0) &&
        e.target.value < minimumValue
      )
        setState({
          ...state,
          error: `Redeem value must be greater than ${minimumValue - 1}!`,
          disable: true,
        });
      if (totalAvailableValue < e.target.value)
        setState({
          ...state,
          error: `Redeem value must be less than or equal to ${totalAvailableValue} !`,
          disable: true,
        });
    } else if (!e.target.value) {
      setState({
        ...state,
        disable: true,
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
        error: null,
        disable: false,
      });
    }
  };

  const handleRedeemApi = async (templates, selectedTemplateCode) => {
    try {
      if (decrypt(localStorage.getItem("Id")) === starHealthMerchantId) {
        const detail = templates?.filter(
          (ele) => ele.code === selectedTemplateCode,
        );
        if (!error) {
          let tempToken = JSON.parse(localStorage.getItem("token_gen"));
          tempToken = tempToken?.access_token;
          let body = JSON.stringify(redeem);
          setLoader(true);
          let response = await transactionRedeem(tempToken, body);
          if (response?.message === "Request processed successfully.") {
            const voucherBody = {
              voucherTemplateCode: detail?.[0]?.code,
              merchantId: detail?.[0]?.merchantId[0],
              customerCode: id,
              value: parseInt(detail?.[0]?.voucherValue),
              amount: parseInt(detail?.[0]?.voucherValue) / 4,
              RedeemTransactionId: response?.data?.currentTransactionId,
            };
            const voucherRes = await voucherPurchase(tempToken, voucherBody);
            {
              if (voucherRes?.message === "Request processed successfully.") {
                let body = {};
                body.customer = {
                  customercode: id,
                };

                body.redeemDetail = {
                  walletType: "Voucher",
                  voucherCode: voucherRes?.data?.code,
                  voucherTemplateCode: voucherRes?.data?.voucherTemplateCode,
                  transactionType: "redeem",
                  transactionDate: getDate(new Date(), "YYYY-MM-DD"),
                };
                const redeemVoucherRes = await RedeemVoucher(tempToken, body);
                if (
                  redeemVoucherRes.message === "Request processed successfully."
                ) {
                  await fetch();
                  setState({
                    ...state,
                    successMsg: "Redeem points successfully",
                    disable: false,
                  });
                  setVoucher({ ...voucher, flag: false });
                } else {
                  setState({
                    ...state,
                    successMsg: "Redeem points failed",
                    disable: false,
                  });
                }
              } else {
                const refundBody = {
                  customer: {
                    customercode: id,
                  },
                  transactionId: response?.data?.currentTransactionId,
                  transactionAmount: 0,
                  transactionDate: getDate(new Date(), "YYYY-MM-DD"),
                };
                const refundRes = await transactionRefund(
                  tempToken,
                  refundBody,
                );
                await fetch();
                if (refundRes?.message === "Request processed successfully.") {
                  setState({
                    ...state,
                    error: "Voucher purchase failed",
                    disable: true,
                  });
                } else {
                  setState({
                    ...state,
                    error: refundRes?.message,
                    disable: true,
                  });
                }
              }
            }
          } else {
            setState({
              ...state,
              error: response?.errors?.[0]?.detail || response?.message,
              disable: true,
            });
          }
        }
      } else {
        if (!error) {
          let tempToken = JSON.parse(localStorage.getItem("token_gen"));
          tempToken = tempToken?.access_token;
          let body = JSON.stringify(redeem);
          setLoader(true);
          let response = await transactionRedeem(tempToken, body);
          await fetch();
          setVoucher({ ...voucher, flag: false });
          if (response?.message === "Request processed successfully.") {
            setState({
              ...state,
              successMsg: "Redeem points successfully",
              disable: false,
            });
          } else {
            setState({
              ...state,
              error: response?.errors?.[0]?.detail || response?.message,
              disable: true,
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  const handleShowModal = (id) => {
    setShowLogin(true);
    setTransactionId(id);
  };

  const displayedArray = activityLogs?.length && activityLogs.slice(0, limit);
  const handleLoadMore = () => {
    setState((prevState) => ({ ...prevState, limit: prevState.limit + 5 }));
  };

  const handleOpenRewardsModal = () => {
    setRedeemModalShow(true);
    setState({ ...state, totalAvailableValue: totalAvailableValue });
  };

  const handleCloseRewardsModal = () => {
    setState({ ...state, successMsg: "", error: "", disable: false });
    setRedeemModalShow(false);
  };

  const openRedeemableModal = () => {
    setRedeemableModalShow(true);
  };

  const closeRedeemableModal = () => {
    setRedeemableModalShow(false);
  };

  const pageSize = 10;
  const pageCount = Math.ceil(total / pageSize);
  const pageCountv = Math.ceil(qualifiedVoucherList.length / pageSize);
  const [matchData, setMatchdata] = useState([]);
  useEffect(() => {
    const matchedVouchers = [];

    voucherTemplate?.forEach((voucherCode) => {
      voucher?.qualifiedVoucherList?.forEach((voucher) => {
        if (voucherCode.code === voucher.templateCode) {
          matchedVouchers.push({
            code: voucherCode?.code,
            value: voucherCode?.earningValue,
            ...(decrypt(localStorage.getItem("Id")) === edsringMerchantId && {
              remarks: voucher.remarks,
            }),
          });
        }
      });
    });

    setMatchdata(matchedVouchers);
  }, [voucherTemplate, voucher.qualifiedVoucherList]);

  const [matchedCode, setMatchedCode] = useState([]);

  useEffect(() => {
    if (
      transaction_s &&
      Array.isArray(transaction_s) &&
      matchData &&
      Array.isArray(matchData)
    ) {
      const matchedVouchers = [];
      transaction_s.forEach((transaction) => {
        if (
          transaction?.qualifiedCampaign &&
          Array.isArray(transaction?.qualifiedCampaign)
        ) {
          const qualifiedCampaign = transaction?.qualifiedCampaign;
          const newStateArray = [];
          matchData?.forEach((voucherCode) => {
            qualifiedCampaign?.forEach((voucher) => {
              if (voucherCode.code === voucher.voucherTemplateCode) {
                newStateArray.push({
                  value: voucherCode.value,
                });
              }
            });
          });

          setMatchedCode(newStateArray);
        }
      });
    }
  }, [matchData, transaction_s]);

  const renderVoucherValue = (transaction, matchedCode) => {
    if (
      transaction.qualifiedCampaign &&
      transaction.qualifiedCampaign.some(
        (voucher) => voucher.type === "voucher",
      )
    ) {
      const voucherValues = transaction.qualifiedCampaign
        .filter((voucher) => voucher.type === "voucher")
        .map(
          (voucher) =>
            matchedCode.find(
              (matchedVoucher) => matchedVoucher.id === voucher.id,
            )?.value || "-",
        );

      return voucherValues.join(", ");
    } else {
      return transaction.transactionDetail.amount || "-";
    }
  };

  const generatePDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");
    const columns = ["Trn ID(last 8 digits)", "Rewards", "Trn Type", "Date"];
    let y = 20;
    columns.forEach((column, index) => {
      pdf.text(column, 10 + index * 40, y);
    });
    y += 10;

    transaction_s?.forEach((transaction) => {
      const last4Digits = transaction?.transactionId.slice(-8); // Extract last 8 digits
      const rowData = [
        last4Digits,
        transaction?.transactionDetail?.transactionType === "redeem"
          ? transaction?.transactionDetail?.values +
            " " +
            transaction?.transactionDetail?.walletType
          : (() => {
              const campaign = transaction?.qualifiedCampaign;
              if (campaign?.length) {
                const total = campaign.reduce(
                  (sum, q) => sum + (q.value > 0 ? q.value : 0),
                  0,
                );
                const type = campaign[0]?.type?.toLowerCase() || "points";
                return `${total} ${type}`;
              } else {
                return "0 point";
              }
            })(),
        transaction?.qualifiedCampaign?.[0]?.walletFor === "Merchant"
          ? "reversal"
          : transaction?.transactionDetail?.transactionType,
        getDisplayDate(transaction?.transactionProcessedDate),
      ];

      rowData.forEach((cell, index) => {
        const xOffset = index === 0 ? 10 : 10 + index * 40;
        pdf.text(String(cell), xOffset, y);
      });
      y += 10;
    });

    pdf.save("report.pdf");
  };

  const generateCSV = () => {
    const data =
      decrypt(localStorage.getItem("Id")) === "MER000174"
        ? [
            [
              "Transaction ID",
              "IsQualified",
              "QR Code Scan",
              "Earning (INR)",
              "Date",
            ],
          ]
        : [["Transaction ID", "Rewards", "Transaction Type", "Date"]];

    transaction_s.forEach((transaction) => {
      const rowData =
        decrypt(localStorage.getItem("Id")) === "MER000174"
          ? [
              transaction?.transactionId,
              (transaction.isQualified =
                transaction?.transactionDetail?.transactionType === "purchase"
                  ? transaction?.qualifiedCampaign?.length
                    ? "Yes"
                    : "No"
                  : "-"),
              "true",
              transaction?.transactionDetail?.transactionType === "redeem"
                ? transaction?.transactionDetail?.values +
                  " " +
                  transaction?.transactionDetail?.walletType
                : (() => {
                    const campaign = transaction?.qualifiedCampaign;
                    if (campaign?.length) {
                      const total = campaign.reduce(
                        (sum, q) => sum + (q.value > 0 ? q.value : 0),
                        0,
                      );
                      const type = campaign[0]?.type?.toLowerCase() || "points";
                      return `${total} ${type}`;
                    } else {
                      return "0 point";
                    }
                  })(),
              getDisplayDate(transaction?.transactionProcessedDate),
            ]
          : [
              transaction?.transactionId,
              transaction?.transactionDetail?.transactionType === "redeem"
                ? transaction?.transactionDetail?.values +
                  " " +
                  transaction?.transactionDetail?.walletType
                : (() => {
                    const campaign = transaction?.qualifiedCampaign;
                    if (campaign?.length) {
                      const total = campaign.reduce(
                        (sum, q) => sum + (q.value > 0 ? q.value : 0),
                        0,
                      );
                      const type = campaign[0]?.type?.toLowerCase() || "points";
                      return `${total} ${type}`;
                    } else {
                      return "0 point";
                    }
                  })(),
              transaction?.qualifiedCampaign?.[0]?.walletFor === "Merchant"
                ? "reversal"
                : transaction?.transactionDetail?.transactionType,
              getDate(transaction?.transactionProcessedDate, "DD-MM-YYYY"),
            ];

      data.push(rowData);
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      data.map((row) => row.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "report.csv");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <Header
        name={`${decrypt(localStorage.getItem("Id")) === starblazeMerchantId ? "Retailer" : "Customer"} View`}
      />
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="dashboard__customerViewMain">
            <div className="dashboard__heading">
              <div className="dashboard__headingLeft">
                <div className="dashboard__headingBackLink">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (source) {
                        const route = getRouteFromSource(source);
                        navigate(route);
                      } else {
                        navigate(-1);
                      }
                    }}
                    state={{
                      from:
                        location?.state?.from === "WalletReport"
                          ? "WalletReport"
                          : "",
                    }}
                  >
                    <img src={backIcon2} alt="" />
                    <div className="dashboard__headingContent">
                      <h3>
                        {location?.state?.from === "WalletReport"
                          ? "Back"
                          : "Back to List"}
                      </h3>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="dashboard__customerViewCard">
              <div className="dashboard__customerViewProfile">
                <div className="dashboard__customerViewImage">
                  <img
                    src={profileImageUrl || profileImage}
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowImageZoom(true)}
                  />
                </div>
                <Modal
                  show={showImageZoom}
                  onHide={() => setShowImageZoom(false)}
                  centered
                  size="lg"
                >
                  <Modal.Body
                    className="text-center p-0"
                    style={{ position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        display: "flex",
                        gap: "10px",
                        zIndex: 1,
                      }}
                    >
                      <i
                        className="fa-solid fa-download"
                        role="button"
                        title="Download"
                        onClick={handleDownloadProfileImage}
                        style={{
                          cursor: "pointer",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                        }}
                      ></i>
                      <i
                        className="fa-solid fa-xmark"
                        role="button"
                        title="Close"
                        onClick={() => setShowImageZoom(false)}
                        style={{
                          cursor: "pointer",
                          background: "#fff",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                        }}
                      ></i>
                    </div>
                    <img
                      src={profileImageUrl || profileImage}
                      alt=""
                      style={{ maxWidth: "100%", maxHeight: "80vh" }}
                    />
                  </Modal.Body>
                </Modal>
                <div className="dashboard__customerViewDetails">
                  <div className="dashboard__customerViewTop">
                    <h2>
                      Personal Detail{" "}
                      {decrypt(localStorage.getItem("Id")) ===
                      edsringMerchantId ? (
                        <CustomerAddEditModal
                          isEdit={true}
                          customerData={customerData}
                          fetchData={fetch}
                        />
                      ) : (
                        <></>
                      )}
                    </h2>
                  </div>
                  {Id !== "MER000252" ? (
                    <div className="dashboard__customerViewBottom">
                      <div className="dashboard__customerViewBlock">
                        <ul>
                          {customerData && schemaData?.length && (
                            <>
                              <li>
                                Customer Code: <span>{customer_Code}</span>
                              </li>
                              {schemaData?.map((item) => (
                                <li key={item.fieldname}>
                                  {item.fielddisplayname}:
                                  {item.fieldname === "membershipcardnumber" ? (
                                    memberCardNumber &&
                                    memberCardNumber.includes("TEM") ? (
                                      <span class="d-flex">
                                        {memberCardNumber}
                                        <i
                                          class="fa-solid fa-pen mx-1"
                                          onClick={() =>
                                            setMembershipCard((prev) => ({
                                              ...prev,
                                              cardUpdateModalShow: true,
                                            }))
                                          }
                                        ></i>
                                      </span>
                                    ) : (
                                      " " + memberCardNumber
                                    )
                                  ) : item?.fieldname === "createdAt" ? (
                                    <span>
                                      {" "}
                                      {getDisplayDate(customerData?.createdAt)}
                                    </span>
                                  ) : (
                                    <span>
                                      {" "}
                                      {item.fieldname === "tiername"
                                        ? customerData?.tier?.name
                                        : customerData[
                                            item.fieldname
                                          ]?.toString()}
                                    </span>
                                  )}
                                </li>
                              ))}
                            </>
                          )}
                        </ul>
                      </div>
                      {/* <div className="dashboard__customerViewLeft">
                        <ul>
                          <li>Name: {name}</li>
                          <li>Contact Number: {mobile}</li>
                          <li>Referral Code: {referralcode}</li>
                          <li>Tier: {tier}</li>
                          <li>Membership Type: {membershipType}</li>
                        </ul>
                      </div>
                      <div className="dashboard__customerViewRight">
                        <ul>
                        
                          <li>Customer Code: {customer_Code}</li>
                          <li>Email ID: {email}</li>
                          <li>Customer ID: {customerid}</li>
                          <li className="d-block">
                            Membership Card:
                            {memberCardNumber &&
                              memberCardNumber.includes("TEM") ? (
                              <span class="d-flex">
                                {memberCardNumber}
                                <i
                                  class="fa-solid fa-pen mx-1"
                                  onClick={() =>
                                    setMembershipCard((prev) => ({
                                      ...prev,
                                      cardUpdateModalShow: true,
                                    }))
                                  }
                                ></i>
                              </span>
                            ) : (
                              " " + memberCardNumber
                            )}
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  ) : (
                    <div className="dashboard__customerViewBottom">
                      <div className="dashboard__customerViewLeft">
                        <ul>
                          <li>Name: {name}</li>
                          <li>Customer Id: {customerid}</li>
                          <li>Referral Code: {referralcode}</li>
                          <li>Tier: {tier}</li>
                        </ul>
                      </div>
                      <div className="dashboard__customerViewRight">
                        <ul>
                          <li>Customer Code: {customer_Code}</li>
                          <li>Referred By: {referredby}</li>
                          <li>Total Investment Amount: {totalInvest}</li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="dashboard__customerViewCard">
              <div className="dashboard__customerViewPointsTabs">
                <Tabs id="customerViewPointsTabs">
                  <Tab eventKey="Timeline" title="Timeline">
                    {Array.isArray(displayedArray) ? (
                      <div className="dashboard__customerViewTimeline">
                        {displayedArray?.length &&
                          displayedArray?.map((item, i) => (
                            <div className="dashboard__customerViewBox" key={i}>
                              <span className="timelineIcon active"></span>
                              <p>
                                {getDate(
                                  item.activityDateTime,
                                  "YYYY-MM-DD hh:mm:ss",
                                )}
                              </p>
                              <h4>
                                Action :-{" "}
                                {item.valueType === "voucher"
                                  ? "Earned Voucher"
                                  : item.action === "Customer Registration"
                                    ? decrypt(localStorage.getItem("Id")) ===
                                      starblazeMerchantId
                                      ? "Retailer Registration"
                                      : item.action
                                    : item.action}
                              </h4>
                              {item.transactionType && (
                                <h4>
                                  Transaction Type:- {item.transactionType}
                                </h4>
                              )}
                              {(item.transactionType == "purchase" ||
                                item.transactionType == "value_transfer") &&
                              (item.value || !item.voucherCode) ? (
                                decrypt(localStorage.getItem("Id")) ===
                                "MER000174" ? (
                                  <h4>Earned Value:- {item?.value}</h4>
                                ) : (
                                  <h4>Earned:- {item?.value} Points</h4>
                                )
                              ) : (
                                item.voucherCode && (
                                  <h4>Earned:- {item.valueType} </h4>
                                )
                              )}
                              {item.transactionType == "redeem" && (
                                <h4>Redeem:- {item.value} Points</h4>
                              )}
                            </div>
                          ))}
                        {limit < activityLogs.length && (
                          <button
                            className="btn btn-primary"
                            onClick={handleLoadMore}
                          >
                            Load More
                          </button>
                        )}
                      </div>
                    ) : (
                      <h6 className="text-center">No Record Found</h6>
                    )}
                  </Tab>
                  <Tab
                    eventKey="Points"
                    title={
                      decrypt(localStorage.getItem("Id")) === "MER000174"
                        ? "Earned Value"
                        : "Points"
                    }
                  >
                    <div className="dashboard__customerViewPoints">
                      <div className="row">
                        <div className="col-lg-10">
                          <div className="row gx-2">
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>
                                  Available Reward{" "}
                                  {decrypt(localStorage.getItem("Id")) ===
                                  "MER000174"
                                    ? "Value"
                                    : "Points"}
                                </h4>
                                <h2>{availableValue}</h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>Available Points for Redemption </h4>
                                <h2>{totalAvailableValue}</h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>Reward Redemption After Date</h4>
                                {redeemablePoint > 0 ? (
                                  <h2>
                                    <span
                                      className="totalReward"
                                      onClick={openRedeemableModal}
                                    >
                                      {redeemablePoint}
                                      <span className="line">|</span>
                                      <i class="fa-solid fa-eye size2"></i>
                                    </span>
                                  </h2>
                                ) : (
                                  <h2>{redeemablePoint}</h2>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>
                                  Total Earned{" "}
                                  {decrypt(localStorage.getItem("Id")) ===
                                  "MER000174"
                                    ? "Value"
                                    : "Points"}
                                </h4>
                                <h2>{totalEarnPoints}</h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>
                                  Total Expired{" "}
                                  {decrypt(localStorage.getItem("Id")) ===
                                  "MER000174"
                                    ? "Value"
                                    : "Points"}
                                </h4>
                                <h2>{totalExpiredPoints} </h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>
                                  Total Redeemed{" "}
                                  {decrypt(localStorage.getItem("Id")) ===
                                  "MER000174"
                                    ? "Value"
                                    : "Points"}
                                </h4>
                                <h2>{totalRedeemPoints}</h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>Transfer Value</h4>
                                <h2>{transferValue}</h2>
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                              <div className="dashboard__customerViewBox">
                                <h4>Total Lock Value</h4>
                                <h2>{totalLockValue}</h2>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-2">
                          <button
                            className="btn btn-primary w-100"
                            disabled={totalAvailableValue > 0 ? false : true}
                            onClick={handleOpenRewardsModal}
                          >
                            Redeem Rewards
                          </button>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  {decrypt(localStorage.getItem("Id")) !== "MER000174" && (
                    <Tab eventKey="Vouchers" title="Vouchers">
                      {qualifiedVoucherList?.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>Voucher Code</th>
                                <th>Value</th>
                                <th>Earned Date</th>
                                <th>Expire Date</th>
                                {decrypt(localStorage.getItem("Id")) ===
                                edsringMerchantId ? (
                                  <th>Remarks</th>
                                ) : (
                                  <></>
                                )}

                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {qualifiedVoucherList &&
                                qualifiedVoucherList.length > 0 &&
                                qualifiedVoucherList
                                  .slice(
                                    currentPagev * pageSize,
                                    (currentPagev + 1) * pageSize,
                                  )
                                  .map((transaction, i) => (
                                    <tr key={i}>
                                      <td>{transaction?.voucherCode}</td>
                                      <td>
                                        {transaction?.earnedValue > 0
                                          ? transaction.earnedValue
                                          : getValue(transaction?.templateCode)}
                                      </td>
                                      <td>
                                        {getDisplayDate(
                                          transaction?.transactionDate,
                                        )}
                                      </td>
                                      <td>
                                        {getDisplayDate(
                                          getVoucherDate(
                                            transaction?.templateCode,
                                          ),
                                        )}
                                      </td>
                                      {decrypt(localStorage.getItem("Id")) ===
                                      edsringMerchantId ? (
                                        <td>{transaction?.remarks}</td>
                                      ) : (
                                        <></>
                                      )}

                                      <td>
                                        {transaction.voucherCode &&
                                          matchedVoucherStatus.map(
                                            (item, index) => {
                                              if (
                                                item.voucherCode &&
                                                item.voucherCode ===
                                                  transaction.voucherCode
                                              ) {
                                                return (
                                                  <button
                                                    key={index}
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                    className={
                                                      item.status
                                                        ? "badge bg-warning"
                                                        : "badge bg-success"
                                                    }
                                                    onClick={() => {
                                                      if (
                                                        decrypt(
                                                          localStorage.getItem(
                                                            "merchantcode",
                                                          ),
                                                        ) === edsringMerchantId
                                                      ) {
                                                        setSelectedVoucher(
                                                          transaction,
                                                        );
                                                        setRemarksModal(true);
                                                      } else {
                                                        handleRedeemtion(
                                                          transaction,
                                                        );
                                                      }
                                                    }}
                                                    disabled={item.status}
                                                  >
                                                    {item.status
                                                      ? "redeemed"
                                                      : "redeem"}
                                                  </button>
                                                );
                                              }
                                              return null;
                                            },
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                            </tbody>
                          </table>
                          <div className="dashboard__paginationBox">
                            <Page
                              currentPage={currentPagev}
                              setCurrentPage={setCurrentPagev}
                              pageCount={pageCountv}
                            />
                          </div>
                        </div>
                      ) : (
                        <h6 className="text-center"> No Record Found</h6>
                      )}
                    </Tab>
                  )}
                  <Tab eventKey="Transactions" title="Transactions">
                    <div
                      className="dropdown"
                      style={{
                        justifyContent: "end",
                        display: "flex",
                        marginBottom: "10px",
                      }}
                    >
                      <button
                        className="btn btn-danger dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        disabled={transaction_s?.length > 0 ? false : true}
                      >
                        Download
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <button className="dropdown-item" onClick={generatePDF}>
                          Download PDF
                        </button>
                        <button className="dropdown-item" onClick={generateCSV}>
                          Download CSV
                        </button>
                      </div>
                    </div>
                    {transaction_s.length > 0 ? (
                      <div className="table-responsive" id="transaction_Report">
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>Transaction ID</th>
                              {/* <th>Transaction Amount</th> */}
                              {decrypt(localStorage.getItem("Id")) ===
                              "MER000174" ? (
                                <th>IsQualified</th>
                              ) : (
                                <th>Rewards</th>
                              )}
                              {decrypt(localStorage.getItem("Id")) ===
                                "MER000174" && <th>QR Code Scan</th>}
                              {decrypt(localStorage.getItem("Id")) ===
                                "MER000174" && <th>Earning (INR)</th>}
                              {decrypt(localStorage.getItem("Id")) !==
                                "MER000174" && <th>Transaction Type</th>}
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {transaction_s &&
                              transaction_s
                                .sort((a, b) => {
                                  const aDiff = Math.abs(
                                    new Date(a.transactionProcessedDate) -
                                      new Date(),
                                  );
                                  const bDiff = Math.abs(
                                    new Date(b.transactionProcessedDate) -
                                      new Date(),
                                  );
                                  return aDiff - bDiff;
                                })
                                .slice(
                                  currentPage * pageSize,
                                  (currentPage + 1) * pageSize,
                                )
                                .map((transaction, i) => (
                                  <tr key={i}>
                                    <td
                                      onClick={() =>
                                        handleShowModal(
                                          transaction?.transactionId,
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "#0d6efd",
                                      }}
                                    >
                                      {transaction?.transactionId}
                                    </td>

                                    {decrypt(localStorage.getItem("Id")) ===
                                      "MER000174" && (
                                      <td>
                                        {
                                          (transaction.isQualified =
                                            transaction?.transactionDetail
                                              ?.transactionType === "purchase"
                                              ? transaction?.qualifiedCampaign
                                                  ?.length
                                                ? "Yes"
                                                : "No"
                                              : "-")
                                        }
                                      </td>
                                    )}
                                    {decrypt(localStorage.getItem("Id")) ===
                                      "MER000174" && <td>true</td>}
                                    <td>
                                      {(() => {
                                        const grouped = Array.isArray(
                                          transaction?.qualifiedCampaign,
                                        )
                                          ? transaction.qualifiedCampaign.reduce(
                                              (acc, item) => {
                                                if (item?.value > 0) {
                                                  const type =
                                                    item?.type?.toLowerCase();
                                                  acc[type] =
                                                    (acc[type] || 0) +
                                                    item.value;
                                                }
                                                return acc;
                                              },
                                              {},
                                            )
                                          : {};

                                        let earning = "";
                                        if (
                                          transaction?.transactionDetail
                                            ?.transactionType === "redeem"
                                        ) {
                                          earning = `${
                                            transaction?.transactionDetail
                                              ?.values || ""
                                          } ${
                                            transaction?.transactionDetail
                                              ?.walletType || ""
                                          }`;
                                        } else if (
                                          transaction?.transactionDetail
                                            ?.transactionType === "refund"
                                        ) {
                                          earning = `${
                                            transaction?.transactionDetail
                                              ?.refundAmount || ""
                                          } point`;
                                        } else if (
                                          transaction?.transactionDetail
                                            ?.transactionType === "reverse"
                                        ) {
                                          earning = `${
                                            transaction?.transactionDetail
                                              ?.values || ""
                                          } ${
                                            transaction?.transactionDetail
                                              ?.walletType || ""
                                          }`;
                                        } else if (
                                          transaction?.transactionDetail
                                            ?.bitType ===
                                            TransactionType.ADD_FUND ||
                                          transaction?.transactionDetail
                                            ?.bitType ===
                                            TransactionType.INVESTMENT
                                        ) {
                                          earning =
                                            transaction?.transactionDetail
                                              ?.totalAmount || "";
                                        } else if (
                                          transaction?.qualifiedCampaign?.[0]
                                            ?.walletFor === "Merchant"
                                        ) {
                                          earning = `${transaction?.qualifiedCampaign?.[0]?.value} point`;
                                        } else if (
                                          Object.keys(grouped).length > 0
                                        ) {
                                          earning = Object.entries(grouped)
                                            .map(([type, total]) =>
                                              type === "voucher"
                                                ? `Earn voucher worth $${total}`
                                                : decrypt(
                                                      localStorage.getItem(
                                                        "Id",
                                                      ),
                                                    ) === "MER000174"
                                                  ? total
                                                  : `${total} point`,
                                            )
                                            .join(", ");
                                        }

                                        return earning;
                                      })()}
                                    </td>

                                    {decrypt(localStorage.getItem("Id")) !==
                                      "MER000174" && (
                                      <td>
                                        <span
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {transaction?.qualifiedCampaign?.[0]
                                            ?.walletFor === "Merchant"
                                            ? "reversal"
                                            : transaction?.transactionDetail
                                                  ?.bitType?.length > 0
                                              ? transaction?.transactionDetail
                                                  ?.bitType
                                              : transaction?.transactionDetail
                                                  ?.transactionType}
                                        </span>
                                      </td>
                                    )}
                                    <td>
                                      {getDisplayDate(
                                        transaction.transactionProcessedDate,
                                      )}
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                        <div className="dashboard__paginationBox">
                          <Page
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            pageCount={pageCount}
                            value={5}
                          />
                        </div>
                      </div>
                    ) : (
                      <h6 className="text-center"> No Record Found</h6>
                    )}
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      {decrypt(localStorage.getItem("merchantcode")) === edsringMerchantId ? (
        <RemarkModal
          isOpen={remarksModal}
          onSubmit={() => handleRedeemtion(selectedVoucher)}
          onChange={(e) => {
            setRemarks(e.target.value);
          }}
          value={remarks}
          onClose={() => {
            setRemarks("");
            setRemarksModal(false);
          }}
        />
      ) : (
        <></>
      )}

      {showLogin && (
        <TransactionViewModal
          show={showLogin}
          close={() => setShowLogin(false)}
          transactionId={showLogin && transactionId}
        />
      )}

      {redeemModalShow && (
        <RedeemRewardsModal
          show={redeemModalShow}
          close={handleCloseRewardsModal}
          handleRedeemApi={handleRedeemApi}
          totalAvailableValue={totalAvailableValue}
          handleChange={handleChange}
          error={error}
          successMsg={successMsg}
          disable={disable}
          inputRedeemPoints={inputRedeemPoints}
        />
      )}
      {redeemableModalShow && (
        <RedeemableModal
          show={redeemableModalShow}
          close={closeRedeemableModal}
          walletSummary={walletSummary}
        />
      )}
      {membershipCard.cardUpdateModalShow && (
        <CardUpdateModal
          show={membershipCard.cardUpdateModalShow}
          close={() =>
            setMembershipCard((prev) => ({
              ...prev,
              cardUpdateModalShow: false,
            }))
          }
          cardNumber={memberCardNumber}
          customer_Code={customer_Code}
          fetchCustomerDetail={fetch}
        />
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  Customer: state.Customer,
});

const mapDispatchToProps = {
  getCustomer,
  clearCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerView);
